import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Microphone, X } from '@phosphor-icons/react';

export const VoiceDictationPromoCard = () => {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem('voice_promo_dismissed') === '1');
  if (dismissed) return null;
  return (
    <div className="relative bg-[#D95800] border-2 border-black rounded-2xl p-4 mb-4 flex flex-wrap items-center gap-3 shadow-[4px_4px_0px_#000]" data-testid="voice-promo-card">
      <button
        onClick={() => { localStorage.setItem('voice_promo_dismissed', '1'); setDismissed(true); }}
        className="absolute top-2 right-2 text-white/70 hover:text-white"
        data-testid="voice-promo-dismiss"
        aria-label="Dismiss"
      >
        <X size={16} weight="bold" />
      </button>
      <span className="w-11 h-11 flex items-center justify-center bg-white border-2 border-black rounded-xl shrink-0">
        <Microphone size={24} weight="fill" className="text-[#D95800]" />
      </span>
      <div className="flex-1 min-w-[200px]">
        <p className="font-black uppercase text-sm text-white">New: Gloves on, hands dirty? Just talk 🎙️</p>
        <p className="text-xs text-white/85 mt-0.5">Tap the mic on job posts, tool listings and AI pricing checklists — we type for you. English & Español.</p>
      </div>
      <button
        onClick={() => navigate('/post-job')}
        className="bg-white text-[#D95800] font-black uppercase text-xs px-4 py-2.5 border-2 border-black rounded-lg shrink-0"
        data-testid="voice-promo-try-btn"
      >
        Try It Now
      </button>
    </div>
  );
};

export default VoiceDictationPromoCard;
